import { Injectable } from '@angular/core';

import { CatalogObject } from '../catalog-object';
import { Project } from '../project/project';
import { Adapter } from './adapter';
import { CatalogObjectAdapterService } from './catalog-object-adapter.service';

@Injectable({
    providedIn: 'root',
})
export class ProjectAdapterService extends CatalogObjectAdapterService implements Adapter<Project> {
    override adapt(item: any): Project {
        const adaptedCatalog: CatalogObject = super.adapt(item);
        const project: Project = adaptedCatalog as Project;

        return project;
    }
}
